import { useReducer } from 'react';
import { Content, Title, InputFormTable } from 'components';
import { Select, Input, Button } from 'antd';
// import { TagApi } from 'api';
import { SearchWordApi } from 'api';
import { styles } from '../styles';
import { useQueryClient } from '@tanstack/react-query';
import MessageAlert from 'utils';

const SearchWordRegisterContent = ({ searchWordList }) => {
  const queryClient = useQueryClient();
  const [state, dispatch] = useReducer(
    (state, action) => {
      switch (action.type) {
        case 'CHANGE_SEARCH_WORD':
          return {
            ...state,
            search_word: action.value,
            order: searchWordList?.length + 1,
          };
        case 'CHANGE_IS_SHOW':
          return {
            ...state,
            is_show: action.value,
          };
        case 'CLEAR':
          return {
            search_word_id: null,
            search_word: '',
            is_show: 'Y',
            order: searchWordList?.length + 1,
          };
        case 'INITIALIZE':
          return {
            ...action.value,
          };
        default:
          throw new Error(`${action.type}을 찾을 수 없습니다.`);
      }
    },
    {
      search_word_id: null,
      search_word: '',
      is_show: 'Y',
      order: searchWordList?.length + 1,
    }
  );

  const handleSave = async () => {
    if (!state.search_word) {
      MessageAlert.warning('추천 검색어를 입력해야 합니다.');
      return;
    }
    if (Array.isArray(searchWordList)) {
      const isAlreadyTagName = searchWordList.some(
        (searchWord) => searchWord.search_word === state.search_word
      );

      if (state.search_word_id === null && isAlreadyTagName) {
        MessageAlert.warning('이미 등록된 검색어입니다.');
        return;
      }
    }

    const api =
      state.search_word_id === null
        ? SearchWordApi.createSearchWord
        : SearchWordApi.updateSearchWord;
    const response = await api({ ...state });

    if (response.status === 200) {
      const message =
        state.search_word_id === null
          ? '검색어를 등록하였습니다.'
          : '검색어를 수정하였습니다.';
      MessageAlert.success(message);

      setTimeout(() => {
        queryClient.resetQueries({ queryKey: ['searchWord'] });
        dispatch({ type: 'CLEAR' });
      }, 100);
    } else {
      MessageAlert.error('추천 검색어 등록을 실패하였습니다.');
    }
  };

  return (
    <Content
      maxWidth={'100%'}
      padding={20}
      borderRadius={4}
      style={{ marginBottom: 40 }}
    >
      <Title style={{ ...styles.subTitle }}>태그 생성</Title>
      <InputFormTable
        form={[
          {
            label: '추천 검색어',
            required: true,
            form: [
              {
                input: (
                  <Input
                    size="large"
                    placeholder="추천검색어 입력"
                    value={state.search_word}
                    onChange={(e) =>
                      dispatch({
                        type: 'CHANGE_SEARCH_WORD',
                        value: e.target.value,
                      })
                    }
                    showCount={true}
                    maxLength={20}
                  />
                ),
              },
            ],
          },
          {
            label: '노출 여부',
            required: true,
            form: [
              {
                input: (
                  <Select
                    size="large"
                    value={state.is_show}
                    options={[
                      { label: '노출', value: 'Y' },
                      { label: '노출안함', value: 'N' },
                    ]}
                    placeholder="노출여부를 선택하세요."
                    onChange={(value) => {
                      dispatch({ type: 'CHANGE_IS_SHOW', value: value });
                    }}
                  />
                ),
              },
            ],
          },
        ]}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 20,
        }}
      >
        <Button
          size="large"
          type="primary"
          style={{ background: 'var(--primary-color)' }}
          onClick={handleSave}
        >
          추천 검색어 생성
        </Button>
      </div>
    </Content>
  );
};

export default SearchWordRegisterContent;
